// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul li[data-v-223f0f50]:before{content:\" \"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
